import { Components, Theme } from '@mui/material';

export const tablePaginationStyles: Components<Theme>['MuiTablePagination'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiTablePagination-displayedRows': {
        lineHeight: '0 !important'
      },
      '& .MuiTablePagination-actions': {
        marginLeft: '15px !important'
      },
      '& .MuiTablePagination-actions .MuiIconButton-root': {
        color: theme.palette.primary.main,
        padding: '6px'
      }
    }),
    toolbar: {
      minHeight: '0 !important'
    }
  }
};
